import React, { useState, useEffect, useRef } from "react";
import { Box, Fade, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import MobileTopBar from "../../components/navigation/MobileTopBar";
import Button from "../../components/inputs/Button";
import TabButton from "../../components/inputs/TabButton";
import MessageBox from "../../components/utils/MessageBox";
import PlanCard from "../../components/cards/PlanCard";
import PaymentHistoryCard from "../../components/cards/PaymentHistoryCard";
import api from "../../components/api";
import PaymentCard from "../../components/cards/PaymentCard";
import Textfield from "../../components/inputs/Textfield";
import CardIcon from "../../components/icons/CardIcon";
import CalendarIcon from "../../components/icons/CalendarIcon";

const AddPaymentCardPage = ({ mobile, height, setLoggedIn, setUser, user, handleLogout }) => {
  const navigate = useNavigate();
  const [activeCard, setActiveCard] = useState(null);
  const [loadingActiveCard, setLoadingActiveCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const cardNumberRef = useRef();
  const [expiry, setExpiry] = useState("");
  const expiryRef = useRef();
  const [error, setError] = useState({});
  const [cardFocused, setCardFocus] = useState(false);

  const getActiveCard = async () => {
    setLoadingActiveCard(true);
    api.getActivePaymentCard(
      (response) => {
        setActiveCard(response);
        setLoadingActiveCard(false);
      },
      (error) => {
        setActiveCard(null);
        setLoadingActiveCard(false);
      }
    );
  };

  useEffect(() => {
    getActiveCard();
  }, []);

  const validateCard = () => {
    let errors = {};
    if (expiry.length < 5) {
      errors.expiry = true;
      errors.msg = "Fecha de vencimiento inválida";
    }
    if (
      !validateCardNumber(cardNumber) ||
      (getCardType(cardNumber) == "amex" ? cardNumber.length != 15 : cardNumber.length != 16)
    ) {
      errors.cardNumber = true;
      errors.msg = "Número de tarjeta inválido";
    }

    setError(errors);
    if (Object.keys(errors).length == 0) addPaymentCard();
  };

  const getCardType = (cardNumber) => {
    if (/^3[47]/.test(cardNumber)) {
      return "amex";
    } else if (/^4/.test(cardNumber)) {
      return "visa";
    } else {
      return "default";
    }
  };

  const validateCardNumber = (cardNumber) => {
    cardNumber = cardNumber.replace(/\s+/g, "");
    if (!/^\d+$/.test(cardNumber)) {
      return false;
    }

    let sum = 0;
    let alternate = false;

    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let digit = parseInt(cardNumber[i], 10);

      if (alternate) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      alternate = !alternate;
    }

    return sum % 10 === 0;
  };

  const addPaymentCard = async () => {
    setLoading(true);
    const expiryArray = expiry.split("/");
    const body = {
      cardNumber,
      cardExpMonth: expiryArray[0],
      cardExpYear: expiryArray[1],
      subscriptionPlanId: undefined,
    };
    await api.addUserPaymentCard(
      body,
      (response) => {
        setLoading(false);
        navigate("/membresia");
      },
      (error) => {
        console.log(error);
        setLoading(false);
        const errors = {
          cardNumber: true,
          expiry: true,
          msg: "Tarjeta no aceptada. Por favor, intente con otra tarjeta.",
        };
        setError(errors);
      }
    );
  };

  return (
    <Box
      sx={{
        height: { height },
        overflow: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        padding: "0px 10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {mobile > 0 && (
        <MobileTopBar showBack onBack={() => navigate("/membresia")}>
          Tarjeta de crédito
        </MobileTopBar>
      )}
      <Box
        style={{
          maxWidth: "700px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          marginTop: "15px",
        }}
      >
        {activeCard && (
          <Typography
            style={{
              fontWeight: "500",
              fontSize: "20px",
              color: "white",
              textAlign: "center",
              lineHeight: "1.2",
              width: "100%",
            }}
          >
            {`Tarjeta actual: ${activeCard.network} terminada en ${activeCard.cardNumber}`}
          </Typography>
        )}
        <Typography
          style={{
            fontWeight: "500",
            fontSize: "16px",
            color: "white",
            textAlign: "center",
            lineHeight: "1.2",
            width: "100%",
          }}
        >
          Datos de la nueva tarjeta de crédito
        </Typography>
        <PaymentCard
          number={cardNumber}
          expiry={expiry}
          cvv={null}
          name={`${user.name} ${user.lastName}`}
          focus={cardFocused}
        />
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Textfield
            hint="Número de la tarjeta"
            onlyNumbers
            maxLength={16}
            onFocus={() => setCardFocus("number")}
            startIcon={<CardIcon />}
            onChange={(e) => setCardNumber(e)}
            error={error.cardNumber}
          ></Textfield>
          <Textfield
            hint="Vencimiento (MM/AA)"
            expiryMode
            onFocus={() => setCardFocus("expiry")}
            startIcon={<CalendarIcon />}
            onChange={(e) => setExpiry(e)}
            error={error.expiry}
          ></Textfield>
        </Box>
        {error.msg && (
          <Typography
            style={{
              fontWeight: "400",
              fontSize: "18px",
              color: "#FF1F01",
              textAlign: "center",
              lineHeight: "1.2",
              //opacity: loading ? 0.5 : 1,
            }}
          >
            {error.msg}
          </Typography>
        )}
        <Button sx={{ maxWidth: "400px", marginTop: "10px" }} loading={loading} onClick={() => validateCard()}>
          Guardar
        </Button>

        {mobile > 0 && (
          <div
            style={{
              width: "100%",
              height: "70px",
              color: "rgba(0,0,0,0)",
            }}
          >
            -
          </div>
        )}
      </Box>
    </Box>
  );
};

export default AddPaymentCardPage;
